module.exports = __webpack_public_path__ + "static/media/about-plan.a20c8755.webp";